/**
 * E-Mail-Vorlagen für den "Per E-Mail senden"-Dialog.
 * Werden vom <SendByEmailDialog /> übernommen — Benutzer kann sie nach dem
 * Übernehmen noch frei anpassen.
 *
 * Variablen-Platzhalter (vom Aufrufer optional ersetzbar):
 *   {Kundenname} {Rechnungsnummer}
 *
 * Falls keine Ersetzung erfolgt, bleibt der Platzhalter stehen und kann manuell
 * ausgefüllt werden.
 */

const SIGN_OFF = `

Herzliche Grüße
Yasemin Kurt-Yilmaz
Homeyoursoul
kontakt@homeyoursoul.de · homeyoursoul.com`;

export const EMAIL_TEMPLATES = [
  {
    id: 'rechnung',
    label: 'Rechnung senden',
    subject: 'Ihre Rechnung von Homeyoursoul',
    message: `Sehr geehrte/r {Kundenname},

vielen Dank für Ihren Einkauf bei Homeyoursoul. Anbei senden wir Ihnen wie gewünscht die Rechnung als PDF.

Bei Fragen stehen wir Ihnen jederzeit gerne zur Verfügung.${SIGN_OFF}`,
  },
  {
    id: 'mahnung_freundlich',
    label: 'Zahlungserinnerung (freundlich)',
    subject: 'Freundliche Erinnerung zu Ihrer Rechnung {Rechnungsnummer}',
    message: `Sehr geehrte/r {Kundenname},

unsere Buchhaltung hat uns darauf hingewiesen, dass die anliegende Rechnung noch offen ist. Vielleicht ist sie im Alltagsstress untergegangen — das kennen wir nur zu gut.

Wir möchten Sie daher freundlich bitten, den Betrag zeitnah zu begleichen. Sollten Sie die Zahlung bereits veranlasst haben, betrachten Sie diese Nachricht bitte als gegenstandslos.${SIGN_OFF}`,
  },
  {
    id: 'katalog',
    label: 'Produktkatalog senden',
    subject: 'Unser aktueller Produktkatalog',
    message: `Guten Tag,

vielen Dank für Ihr Interesse an Homeyoursoul. Anbei senden wir Ihnen wie gewünscht unseren aktuellen Produktkatalog als PDF.

Wenn Sie zu einzelnen Artikeln Fragen haben oder ein individuelles Angebot wünschen, melden Sie sich jederzeit gerne.${SIGN_OFF}`,
  },
  {
    id: 'grosshandel',
    label: 'Großhandels-/Wiederverkäufer-Anfrage',
    subject: 'Ihre Wiederverkäufer-Anfrage bei Homeyoursoul',
    message: `Guten Tag,

vielen Dank für Ihr Interesse an einer Zusammenarbeit mit Homeyoursoul. Im Anhang finden Sie unseren aktuellen Katalog sowie unsere Konditionen für Wiederverkäufer.

Gerne vereinbare ich mit Ihnen ein kurzes Telefonat, um Ihre Wünsche und Bestellmengen genauer zu besprechen. Senden Sie mir einfach 2–3 Terminvorschläge zurück.${SIGN_OFF}`,
  },
  {
    id: 'lieferschein',
    label: 'Lieferschein nachsenden',
    subject: 'Ihr Lieferschein von Homeyoursoul',
    message: `Sehr geehrte/r {Kundenname},

anbei senden wir Ihnen den Lieferschein zu Ihrer Bestellung. Bitte heben Sie diesen für Ihre Unterlagen auf.

Sollten Sie Fragen zu einzelnen Positionen haben, melden Sie sich gerne.${SIGN_OFF}`,
  },
  {
    id: 'storno',
    label: 'Storno / Gutschrift',
    subject: 'Ihre Gutschrift von Homeyoursoul',
    message: `Sehr geehrte/r {Kundenname},

wie besprochen erhalten Sie anbei die Gutschrift zur Rechnung {Rechnungsnummer}. Der Betrag wird in den nächsten Werktagen auf Ihr Konto erstattet.

Wir bitten die Unannehmlichkeiten zu entschuldigen und danken Ihnen für Ihr Verständnis.${SIGN_OFF}`,
  },
  {
    id: 'reklamation',
    label: 'Reklamation beantworten',
    subject: 'Zu Ihrer Reklamation bei Homeyoursoul',
    message: `Sehr geehrte/r {Kundenname},

vielen Dank für Ihre Rückmeldung. Es tut uns aufrichtig leid, dass Sie mit Ihrer Bestellung nicht zufrieden sind — bei handgefertigten Produkten passiert uns das zum Glück selten, aber wenn doch, kümmern wir uns persönlich darum.

Anbei finden Sie die relevanten Unterlagen zu Ihrem Anliegen. Wir melden uns innerhalb der nächsten Werktage mit einer konkreten Lösung bei Ihnen.${SIGN_OFF}`,
  },
  {
    id: 'versandverspaetung',
    label: 'Versandverspätung',
    subject: 'Information zu Ihrer Bestellung bei Homeyoursoul',
    message: `Sehr geehrte/r {Kundenname},

ich möchte Sie persönlich darüber informieren, dass sich der Versand Ihrer Bestellung leider etwas verzögert. Der Grund: [hier kurz erläutern – z.B. „eine handgefertigte Position braucht noch ein paar Tage mehr in der Werkstatt" oder „der Paketdienst meldet aktuelle Engpässe"].

Voraussichtlich geht Ihr Paket bis zum [neues Versanddatum eintragen] auf die Reise. Sobald die Sendung unterwegs ist, erhalten Sie automatisch die Tracking-Nummer.

Es tut mir aufrichtig leid für die Verzögerung — Ihre Bestellung wird mit derselben Sorgfalt fertiggestellt wie immer. Bei Fragen melden Sie sich gerne jederzeit direkt bei mir.${SIGN_OFF}`,
  },
  {
    id: 'danke',
    label: 'Persönliches Dankeschön',
    subject: 'Vielen Dank für Ihren Einkauf bei Homeyoursoul ',
    message: `Sehr geehrte/r {Kundenname},

ich möchte Ihnen ganz persönlich Danke sagen — für Ihren Einkauf, Ihr Vertrauen und Ihre Unterstützung meines kleinen handgemachten Shops.

Jedes Stück fertige ich mit viel Liebe in meiner Werkstatt in Bisingen. Wenn Sie mögen, würde ich mich riesig über ein Foto von Ihrem Lieblingsstück oder eine kurze Bewertung freuen.

Von Herzen${SIGN_OFF}`,
  },
];

/**
 * Replace placeholders in a template string with actual values.
 * Unmatched placeholders are left as-is for manual editing.
 */
export function applyTemplateVars(text, vars = {}) {
  if (!text) return '';
  return Object.entries(vars).reduce(
    (acc, [key, val]) => acc.replace(new RegExp(`\\{${key}\\}`, 'g'), val || `{${key}}`),
    text
  );
}
